import { IFirmwareContext, IFilterValues } from './firmwareContext';

export enum FirmwareActionTypes {
	SET_FIRMWARE = 'SET_FIRMWARE',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_TYPE_FIRMWARE = 'CHANGE_TYPE_FIRMWARE',
	TOGGLE_UNASSIGNED_FIRMWARE = 'TOGGLE_UNASSIGNED_FIRMWARE',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
}

interface ISetFirmware {
	type: FirmwareActionTypes.SET_FIRMWARE;
	payload: {
		firmware: IFirmwareContext['firmware'];
		typeOfModalWindow: IFirmwareContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: FirmwareActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IFirmwareContext['searchString'];
	};
}

interface IChangeTypeFirmware {
	type: FirmwareActionTypes.CHANGE_TYPE_FIRMWARE;
	payload: {
		IDSelectedTypeFirmware: IFirmwareContext['IDSelectedTypeFirmware'];
	};
}

interface IToggleUnassignedFirmware {
	type: FirmwareActionTypes.TOGGLE_UNASSIGNED_FIRMWARE;
}

interface ISetSortBy {
	type: FirmwareActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IFirmwareContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: FirmwareActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IFirmwareContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: FirmwareActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IFirmwareContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: FirmwareActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IFirmwareContext['IDForDeletion'];
		typeOfModalWindow: IFirmwareContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: FirmwareActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetFiltersFromQueryString {
	type: FirmwareActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

interface IChangeTypeOfModalWindow {
	type: FirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IFirmwareContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: FirmwareActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IFirmwareContext['errorResponseData'];
		typeOfModalWindow: IFirmwareContext['typeOfModalWindow'];
	};
}

export type TFirmwareAction =
	| ISetFirmware
	| IChangeSearchString
	| IChangeTypeFirmware
	| IToggleUnassignedFirmware
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IResetSelectedControls
	| ISetFiltersFromQueryString
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo;
